import React from "react";
import { useNavigate } from "react-router-dom";
import quizzes from "../data/quizzes";
import InstallPWA from "../components/InstallPWA";
import { theme } from "../styles/theme";

function SelectQuiz() {
  const navigate = useNavigate();

  // Lista de quizzes formatada com informações essenciais
  const quizList = Object.entries(quizzes).map(([id, quiz], index) => ({
    id,
    title: quiz.title || `Teste ${index + 1}`,
    questionCount: quiz.length,
    difficulty: id === "1" ? "Fácil" : id === "2" ? "Médio" : "Difícil",
    color: id === "1" ? theme.colors.secondary : id === "2" ? theme.colors.warning : theme.colors.primary,
  }));

  return (
    <div style={{
        minHeight: "100vh",
      backgroundColor: theme.colors.gray[50],
      padding: `${theme.spacing['2xl']} ${theme.spacing.xl}`,
      fontFamily: theme.typography.fontFamily.primary,
    }}>
      <InstallPWA />
      <div style={{ maxWidth: "800px", margin: "0 auto" }}>
        {/* Header Minimalista */}
        <div style={{ textAlign: "center", marginBottom: theme.spacing['3xl'] }}>
          <h1 style={{
            fontSize: theme.typography.fontSize['3xl'],
            fontWeight: theme.typography.fontWeight.bold,
            color: theme.colors.gray[800],
            marginBottom: theme.spacing.md,
          }}>
            Escolha o Seu Teste
      </h1>
          <p style={{
            fontSize: theme.typography.fontSize.lg,
            color: theme.colors.gray[600],
          }}>
            Selecione um teste para começar a praticar
          </p>
        </div>

        {/* Grid de Testes */}
        <div style={{
          display: "grid",
          gridTemplateColumns: window.innerWidth < 768 ? "1fr" : "repeat(auto-fit, minmax(280px, 1fr))",
          gap: window.innerWidth < 768 ? theme.spacing.md : theme.spacing.lg,
        }}>
        {quizList.map((quiz) => (
            <div
            key={quiz.id}
            onClick={() => navigate(`/quiz/${quiz.id}`)}
            style={{
                backgroundColor: theme.colors.white,
                borderRadius: theme.borderRadius.xl,
                padding: theme.spacing.xl,
                boxShadow: theme.shadows.md,
                cursor: "pointer",
                transition: theme.transitions.normal,
                border: `2px solid transparent`,
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "translateY(-4px)";
                e.target.style.boxShadow = theme.shadows.lg;
                e.target.style.borderColor = quiz.color;
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = theme.shadows.md;
                e.target.style.borderColor = "transparent";
              }}
            >
              {/* Indicador de Dificuldade */}
              <div style={{
                position: "absolute",
                top: theme.spacing.md,
                right: theme.spacing.md,
                padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
                backgroundColor: quiz.color,
                color: theme.colors.white,
                borderRadius: theme.borderRadius.sm,
                fontSize: theme.typography.fontSize.xs,
                fontWeight: theme.typography.fontWeight.semibold,
              }}>
                {quiz.difficulty}
              </div>

              {/* Conteúdo do Card */}
              <div style={{ marginBottom: theme.spacing.lg }}>
                <h3 style={{
                  fontSize: theme.typography.fontSize.xl,
                  fontWeight: theme.typography.fontWeight.bold,
                  color: theme.colors.gray[800],
                  marginBottom: theme.spacing.sm,
                }}>
                  {quiz.title}
                </h3>
                <p style={{
                  fontSize: theme.typography.fontSize.base,
                  color: theme.colors.gray[600],
                  lineHeight: 1.5,
                }}>
                  {quiz.questionCount} perguntas sobre código da estrada
                </p>
              </div>

              {/* Estatísticas Simples */}
              <div style={{
              display: "flex",
                justifyContent: "space-between",
              alignItems: "center",
                padding: `${theme.spacing.md} 0`,
                borderTop: `1px solid ${theme.colors.gray[200]}`,
              }}>
                <span style={{
                  fontSize: theme.typography.fontSize.sm,
                  color: theme.colors.gray[600],
                }}>
                  📝 {quiz.questionCount} perguntas
                </span>
                <span style={{
                  fontSize: theme.typography.fontSize.sm,
                  color: theme.colors.gray[600],
                }}>
                  ⏱️ ~{Math.ceil(quiz.questionCount * 1.2)} min
                </span>
              </div>

              {/* Botão de Ação */}
              <button
                style={{
                  width: "100%",
                  marginTop: theme.spacing.lg,
                  padding: theme.spacing.md,
              backgroundColor: quiz.color,
                  color: theme.colors.white,
              border: "none",
                  borderRadius: theme.borderRadius.md,
                  fontSize: theme.typography.fontSize.base,
                  fontWeight: theme.typography.fontWeight.semibold,
              cursor: "pointer",
                  transition: theme.transitions.normal,
            }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "scale(1.02)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "scale(1)";
                }}
          >
                Começar Teste
          </button>
            </div>
        ))}
        </div>

        {/* Estatísticas Gerais Simples */}
        <div style={{
          marginTop: theme.spacing['3xl'],
          padding: theme.spacing.xl,
          backgroundColor: theme.colors.white,
          borderRadius: theme.borderRadius.xl,
          boxShadow: theme.shadows.sm,
          textAlign: "center",
        }}>
          <h3 style={{
            fontSize: theme.typography.fontSize.lg,
            fontWeight: theme.typography.fontWeight.semibold,
            color: theme.colors.gray[700],
            marginBottom: theme.spacing.lg,
          }}>
            📊 Resumo da Plataforma
          </h3>
          <div style={{
            display: "grid",
            gridTemplateColumns: window.innerWidth < 768 ? "repeat(2, 1fr)" : "repeat(auto-fit, minmax(150px, 1fr))",
            gap: window.innerWidth < 768 ? theme.spacing.md : theme.spacing.lg,
          }}>
            <div>
              <div style={{
                fontSize: theme.typography.fontSize['2xl'],
                fontWeight: theme.typography.fontWeight.bold,
                color: theme.colors.primary,
                marginBottom: theme.spacing.xs,
              }}>
                {Object.keys(quizzes).length}
              </div>
              <div style={{
                fontSize: theme.typography.fontSize.sm,
                color: theme.colors.gray[600],
              }}>
                Testes Disponíveis
              </div>
            </div>
            <div>
              <div style={{
                fontSize: theme.typography.fontSize['2xl'],
                fontWeight: theme.typography.fontWeight.bold,
                color: theme.colors.secondary,
                marginBottom: theme.spacing.xs,
              }}>
                {Object.values(quizzes).reduce((total, quiz) => total + quiz.length, 0)}
              </div>
              <div style={{
                fontSize: theme.typography.fontSize.sm,
                color: theme.colors.gray[600],
              }}>
                Total de Perguntas
              </div>
            </div>
            <div>
              <div style={{
                fontSize: theme.typography.fontSize['2xl'],
                fontWeight: theme.typography.fontWeight.bold,
                color: theme.colors.info,
                marginBottom: theme.spacing.xs,
              }}>
                95%
              </div>
              <div style={{
                fontSize: theme.typography.fontSize.sm,
                color: theme.colors.gray[600],
              }}>
                Taxa de Aprovação
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SelectQuiz;
